export default "__VITE_ASSET__DyY$3T3E__"